import { SVGProps } from 'react';

const SvgCalendarSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M11.167 1.333a.5.5 0 0 0-1 0v.834H5.833v-.834a.5.5 0 0 0-1 0v.834h-1.5C2.321 2.167 1.5 2.987 1.5 4v9.333c0 1.013.82 1.834 1.833 1.834h9.334c1.012 0 1.833-.821 1.833-1.834V4c0-1.013-.82-1.833-1.833-1.833h-1.5v-.834ZM13.5 6.167V4a.833.833 0 0 0-.833-.833h-1.5V4a.5.5 0 0 1-1 0v-.833H5.833V4a.5.5 0 0 1-1 0v-.833h-1.5A.833.833 0 0 0 2.5 4v2.167h11Zm-11 1h11v6.166c0 .46-.373.834-.833.834H3.333a.833.833 0 0 1-.833-.834V7.167Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgCalendarSmall;
